<template>
  <div>
    <div class="bg-white" v-if="isPC">
      <search-head></search-head>
      <div class="w">
        <div class="tutorial " v-for="(item,index) in categoryList" :key="index">
          <h1 class="tutorial-title">{{item.name}}</h1>
          <div class="f fw-w">
            <div class="tutorail-box f--c pointer" v-for="(e,i) in item.childList" :key="i" @click="goTutorialDetail(item.classificationId,e.name,e.fullId)">
              <img class="svg-icon" v-if="checkIconName(e.name,'account')" src="@/assets/img/help-center/account.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Benefits')" src="@/assets/img/help-center/Benefits.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Filter')" src="@/assets/img/help-center/Filter.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Inspection')" src="@/assets/img/help-center/Inspection.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Intro')" src="@/assets/img/help-center/Intro.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Join')" src="@/assets/img/help-center/Join.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Listing')" src="@/assets/img/help-center/Listing.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Managing')" src="@/assets/img/help-center/Managing.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Processing')" src="@/assets/img/help-center/Processing.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Purchasing')" src="@/assets/img/help-center/Purchasing.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Refund Policy')" src="@/assets/img/help-center/Refund Policy.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Return')" src="@/assets/img/help-center/Return.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Shipping')" src="@/assets/img/help-center/Shipping.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Sync')" src="@/assets/img/help-center/Sync.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'team-fill')" src="@/assets/img/help-center/team-fill.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Understand')" src="@/assets/img/help-center/Understand.svg" alt="" lazy />
              <img class="svg-icon" v-if="checkIconName(e.name,'Updating')" src="@/assets/img/help-center/Updating.svg" alt="" lazy />
              <span> {{e.name}} </span>
            </div>
          </div>
        </div>
        <div class="faq-list">
          <h1>{{ $t('Home.helpCenter.Tutorial.FAQ') }}</h1>
          <div class="faq-box">
            <div class="faq-list-child" v-for="(item,index) in essayList" :key="index">
              <a @click="$router.push(`/faq/${item.fullName}`)" style="text-decoration:none" href="javascript:void(0);">{{item.title}}</a>
            </div>
            <a href="/faq">{{ $t('Home.helpCenter.Tutorial.READMORE') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mobile-tutorial-container">
      <div style="margin:0 0.32rem;">
        <MobileSerachHead />
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="Tutorial" name="first">
          <div class="main-box">
            <div class="mobile-tutorial " v-for="(item,index) in categoryList" :key="index">
              <h1 class="mobile-tutorial-title">{{item.name}}</h1>
              <div class="mobile-tutorail-box f--c pointer" v-for="(e,i) in item.childList" :key="i" @click="$router.push(`/tutorial-content/${item.classificationId}`)">
                <img class="svg-icon" v-if="checkIconName(e.name,'account')" src="@/assets/img/help-center/account.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Benefits')" src="@/assets/img/help-center/Benefits.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Filter')" src="@/assets/img/help-center/Filter.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Inspection')" src="@/assets/img/help-center/Inspection.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Intro')" src="@/assets/img/help-center/Intro.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Join')" src="@/assets/img/help-center/Join.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Listing')" src="@/assets/img/help-center/Listing.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Managing')" src="@/assets/img/help-center/Managing.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Processing')" src="@/assets/img/help-center/Processing.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Purchasing')" src="@/assets/img/help-center/Purchasing.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Refund Policy')" src="@/assets/img/help-center/Refund Policy.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Return')" src="@/assets/img/help-center/Return.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Shipping')" src="@/assets/img/help-center/Shipping.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Sync')" src="@/assets/img/help-center/Sync.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'team-fill')" src="@/assets/img/help-center/team-fill.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Understand')" src="@/assets/img/help-center/Understand.svg" alt="" lazy />
                <img class="svg-icon" v-if="checkIconName(e.name,'Updating')" src="@/assets/img/help-center/Updating.svg" alt="" lazy />
                <span> {{e.name}} </span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="FAQ" name="second">
          <div class="main-box">
            <div class="mobile-faq-list">
              <el-collapse v-model="activeKey" accordion @change="handleChange">
                <el-collapse-item :title="item.name" :name="index+1" v-for="(item,index) in faqCategoryList" :key="index">
                  <div v-for="(item,index) in faqEssayList" :key="index">
                    <div class="mobile-essay-title">{{item.title}}</div>
                    <div class="mobile-essay-content" v-html="item.content"></div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import SearchHead from './components/SearchHead'
import MobileSerachHead from './components/MobileSerachHead'
import API from '@/api'
import _ from 'lodash'
export default {
  components: { SearchHead, MobileSerachHead },
  data() {
    return {
      activeName: 'first',
      listForm: {
        pageNumber: 1,
        pageSize: 10000
      },
      activeKey: '',
      essayForm: {
        pageNumber: 1,
        pageSize: 4,
        labelName: 'FAQ'
      },
      faqForm: {
        pageNumber: 1,
        pageSize: 1000,
        labelName: 'FAQ'
      },
      input: '',
      categoryList: [],
      essayList: [],
      faqCategoryList: [],
      faqEssayList: []
    }
  },
  computed: {

  },
  created() {
    this.getEssayCategory()
    this.getEssayList()
  },
  methods: {
    handleChange(value) {
      if (value) {
        this.faqForm.classificationId = this.faqCategoryList[value - 1].classificationId
        API.getEssayList(this.faqForm).then(res => {
          this.faqEssayList = _.get(res, 'data.list', [])
          this.$forceUpdate()
        })
      }
    },
    checkIconName(title, name) {
      return title.toLowerCase().indexOf(name.toLowerCase()) > -1
    },
    getEssayCategory() {
      API.getEssayCategory(this.listForm).then(res => {
        this.categoryList = res.data.list.filter(item => { return !item.labelName || item.labelName === 'Tutorial' })
        this.faqCategoryList = res.data.list.filter(item => { return item.labelName === 'FAQ' })
      })
    },
    getEssayList() {
      API.getEssayList(this.essayForm).then(res => {
        this.essayList = res.data.list
      })
    },

    goTutorialDetail(category_id, className, fullId) {
      this.$router.push({
        path: '/tutorial-content',
        query: {
          category_id: category_id,
          name: className
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.tutorial {
  padding: 37px 0 0;
  .tutorial-title {
    font-size: 25px;
    font-weight: 600;
    color: #10141d;
    line-height: 60px;
    padding-bottom: 42px;
    text-align: center;
  }
  .tutorail-box {
    width: 32%;
    height: 114px;
    margin-right: 2%;
    margin-bottom: 2%;
    border: 0.5px solid #dddcdf;
    border-radius: 4px;
    padding: 0 30px;
    span {
      font-size: 20px;
      font-weight: 500;
      text-align: left;
      color: #121e26;
      line-height: 60px;
    }
  }
  .tutorail-box:nth-child(3) {
    margin-right: 0;
  }
  .tutorail-box:hover {
    border: 1px solid #99c41c;
    border-radius: 4px;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.12);
    transform: translateY(-3px);
    transition: all 150ms ease;
  }
}
.faq-list {
  padding: 40px 0 120px 16px;
  a {
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
    color: #121e26;
    line-height: 60px;
  }
  h1 {
    font-size: 25px;
    font-weight: 600;
    text-align: left;
    color: #10141d;
    line-height: 60px;
  }
}
.faq-box {
  padding: 0 16px;
  border-radius: 4px;
  border: 0.5px solid #dddcdf;
}
.faq-list-child {
  height: 63px;
  font-size: 16px;
  font-weight: 400;
  color: #10141d;
  line-height: 60px;
  border-bottom: 0.5px solid #dddcdf;
}
.svg-icon {
  display: inline-block;
  margin-right: 15px;
}

// 移动端样式
.mobile-tutorial-container {
  width: 100%;
  min-height: 100vh;
  padding: 0.2rem 0 0.5rem;
}
.mobile-tutorial {
  width: 100%;
  padding: 0.32rem 0.32rem 0;
}
.mobile-tutorial-title {
  font-weight: 600;
  font-size: 0.32rem;
  color: #000000;
}
.mobile-tutorail-box {
  height: 1.2rem;
  width: 100%;
  padding-left: 0.44rem;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin-top: 0.22rem;
  span {
    font-size: 0.28rem;
    color: #10141d;
    font-weight: 400;
  }
}
.mobile-tutorail-box:hover {
  border: 1px solid #99c41c;
  border-radius: 4px;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.12);
  transform: translateY(-3px);
  transition: all 150ms ease;
}
/deep/.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
/deep/.el-tabs__item {
  font-size: 0.36rem;
  font-weight: 400;
}
/deep/.el-tabs__item .is-top .is-active {
  font-weight: 600;
}
/deep/.el-tabs__active-bar {
  height: 3px;
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px;
}
.mobile-faq-list {
  padding: 0.32rem 0.32rem 0;
}
/deep/.el-collapse-item__header {
  border: none;
  font-weight: 500;
  font-size: 0.32rem;
  line-height: 0.48rem;
  color: #10141d;
}
/deep/.el-collapse {
  border: none;
}
/deep/.el-collapse-item__wrap {
  border: none;
}
.mobile-essay-title {
  font-size: 0.28rem;
  line-height: 0.42rem;
  color: #10141d;
}
.mobile-essay-content {
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.42rem;
  color: #4f4f4f;
}
.main-box {
  height: 75vh;
  overflow-y: scroll;
  // margin-right: -0.2rem;
}

</style>
